import React from "react";

export default function SystemTransition({
  title = "Preparando tu espacio de trabajo",
  subtitle = "Validando acceso seguro",
  mode = "default",
}) {
  return (
    <div className="ip-transition-page">
      <div className="ip-transition-glow ip-transition-glow-a" />
      <div className="ip-transition-glow ip-transition-glow-b" />

      <main className="ip-transition-content">
        <div className="ip-transition-logo">
          <span className="ip-transition-logo-mark">IP</span>
          <span className="ip-transition-logo-name">DEPOT</span>
        </div>

        <div className="ip-transition-product">
          Plataforma Administrativa
        </div>

        <div
          className={`ip-transition-loader ${
            mode === "logout"
              ? "ip-transition-loader-logout"
              : ""
          }`}
          aria-hidden="true"
        >
          <div className="ip-transition-ring" />
          <div className="ip-transition-dot" />
        </div>

        <h1 className="ip-transition-title">
          {title}
        </h1>

        <p className="ip-transition-subtitle">
          {subtitle}
        </p>

        <div className="ip-transition-progress">
          <div className="ip-transition-progress-bar" />
        </div>

        <div className="ip-transition-security">
          <span className="ip-transition-security-dot" />
          Sesión protegida
        </div>
      </main>

      <footer className="ip-transition-footer">
        Tecnología · Seguridad · Innovación
      </footer>

      <style>{`
        .ip-transition-page {
          position: fixed;
          inset: 0;
          z-index: 999999;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background:
            linear-gradient(
              145deg,
              #f7f8fa 0%,
              #ffffff 48%,
              #f4f6f8 100%
            );
          font-family:
            Inter,
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            sans-serif;
          color: #151922;
        }

        .ip-transition-content {
          position: relative;
          z-index: 2;
          width: min(420px, calc(100vw - 44px));
          text-align: center;
          animation: ip-transition-enter 320ms ease-out both;
        }

        .ip-transition-logo {
          display: inline-flex;
          align-items: baseline;
          gap: 7px;
          letter-spacing: 0.06em;
        }

        .ip-transition-logo-mark {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 38px;
          border-radius: 10px;
          background: #171c24;
          color: #ffffff;
          font-size: 15px;
          font-weight: 850;
          letter-spacing: -0.03em;
          box-shadow:
            0 8px 24px rgba(17, 24, 39, 0.13);
        }

        .ip-transition-logo-name {
          font-size: 22px;
          font-weight: 850;
          letter-spacing: 0.14em;
          color: #171c24;
        }

        .ip-transition-product {
          margin-top: 10px;
          font-size: 11px;
          font-weight: 650;
          letter-spacing: 0.11em;
          text-transform: uppercase;
          color: #8a919c;
        }

        .ip-transition-loader {
          position: relative;
          width: 52px;
          height: 52px;
          margin: 40px auto 25px;
        }

        .ip-transition-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 3px solid #e8ebef;
          border-top-color: #171c24;
          animation: ip-transition-spin 820ms linear infinite;
        }

        .ip-transition-dot {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 7px;
          height: 7px;
          margin: -3.5px 0 0 -3.5px;
          border-radius: 50%;
          background: #171c24;
          opacity: 0.22;
        }

        .ip-transition-loader-logout .ip-transition-ring {
          animation-duration: 1050ms;
        }

        .ip-transition-title {
          margin: 0;
          color: #171c24;
          font-size: 19px;
          line-height: 1.3;
          font-weight: 720;
          letter-spacing: -0.015em;
        }

        .ip-transition-subtitle {
          max-width: 340px;
          margin: 8px auto 22px;
          color: #858c97;
          font-size: 13px;
          line-height: 1.55;
        }

        .ip-transition-progress {
          position: relative;
          width: 190px;
          height: 2px;
          margin: 0 auto;
          overflow: hidden;
          border-radius: 999px;
          background: #e9ecf0;
        }

        .ip-transition-progress-bar {
          position: absolute;
          top: 0;
          left: 0;
          width: 65%;
          height: 100%;
          border-radius: inherit;
          background: #1d222b;
          animation:
            ip-transition-progress 1.35s ease-in-out infinite;
        }

        .ip-transition-security {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          margin-top: 17px;
          color: #a0a6af;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        .ip-transition-security-dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #6b7280;
        }

        .ip-transition-footer {
          position: absolute;
          z-index: 2;
          right: 20px;
          bottom: 26px;
          left: 20px;
          text-align: center;
          color: #a1a7b0;
          font-size: 10px;
          font-weight: 550;
          letter-spacing: 0.08em;
        }

        .ip-transition-glow {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
        }

        .ip-transition-glow-a {
          top: -260px;
          left: -220px;
          width: 620px;
          height: 620px;
          background:
            radial-gradient(
              circle,
              rgba(17, 24, 39, 0.045) 0%,
              rgba(17, 24, 39, 0) 68%
            );
        }

        .ip-transition-glow-b {
          right: -220px;
          bottom: -300px;
          width: 660px;
          height: 660px;
          background:
            radial-gradient(
              circle,
              rgba(17, 24, 39, 0.035) 0%,
              rgba(17, 24, 39, 0) 70%
            );
        }

        @keyframes ip-transition-spin {
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes ip-transition-progress {
          0% {
            transform: translateX(-105%);
          }

          50% {
            transform: translateX(45%);
          }

          100% {
            transform: translateX(160%);
          }
        }

        @keyframes ip-transition-enter {
          from {
            opacity: 0;
            transform: translateY(7px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .ip-transition-content,
          .ip-transition-ring,
          .ip-transition-progress-bar {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
          }
        }
      `}</style>
    </div>
  );
}